// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27X9B","buttons":"styles_buttons__3r7vP"};